// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from 'antd';
import Header from './components/Header';
import AppFooter from './components/FooterItem';
import Home from './pages/Home';
import Archive from './pages/Archive';
import About from './pages/About';
import Auth from './pages/Auth';
import WritePost from './pages/WritePost';
import PostDetail from './pages/PostDetail';
import NotFound from './pages/NotFound';
import initAppData from './Api/mockData';
import './App.css';

const { Content } = Layout;

const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isLoggedIn') === 'true';
  return isAuthenticated ? children : <Navigate to="/auth" />;
};

// 独立的登录页布局（无Header/Footer）
const AuthLayout = () => {
  return <Auth />;
};

function App() {
  useEffect(() => {
    initAppData();
  }, []);

  return (
    <Router>
      <Routes>
        {/* 根路径直接显示登录页 */}
        <Route path="/" element={<AuthLayout />} />
        
        {/* 登录页 */}
        <Route path="/auth" element={<AuthLayout />} />
        
        {/* 所有需要登录的页面 */}
        <Route path="/*" element={
          <PrivateRoute>
            <Layout className="app-layout">
              <Header />
              <Content className="app-content">
                <Routes>
                  <Route path="/home" element={<Home />} />
                  <Route path="/archive" element={<Archive />} />
                  <Route path="/about" element={<NotFound />} />
                  <Route path="/profile" element={<About />} />
                  <Route path="/post/:id" element={<PostDetail />} />
                  <Route path="/write" element={<WritePost />} />
                  <Route path="/write/:id" element={<WritePost />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Content>
              <AppFooter />
            </Layout>
          </PrivateRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;